import { FunctionComponent, useMemo } from "react";

import { faSliders, faWandMagicSparkles } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { Icon } from "@/components/Icon/Icon";
import { Tooltip } from "@/components/Tooltip/Tooltip";

import { FrameworkOverrides } from "./types";

interface FrameworksRowProps {
	frameworkOverrides: FrameworkOverrides;
	isGenerating: boolean;
	onOpenFrameworksModal: () => void;
	/** Compact (DetailView "Chat" tab / extension panel): icon-only button + tooltip. */
	compact?: boolean;
}

export const FrameworksRow: FunctionComponent<FrameworksRowProps> = ({
	frameworkOverrides,
	isGenerating,
	onOpenFrameworksModal,
	compact,
}) => {
	const selectedCount = useMemo(
		() =>
			[
				frameworkOverrides.step1FrameworkId,
				frameworkOverrides.step2FrameworkId,
				frameworkOverrides.step3FrameworkId,
			].filter((id) => id != null).length,
		[frameworkOverrides]
	);

	return (
		<div className="flex items-center justify-between gap-2">
			<div className="flex items-center gap-2 min-w-0">
				<span className="text-[10px] font-semibold text-text-meta tracking-wider uppercase whitespace-nowrap">
					Frameworks
				</span>
				<span className="rounded-md border border-border-light bg-brand-white px-2 py-0.5 flex items-center gap-1.5 text-xs text-text whitespace-nowrap">
					{selectedCount === 0 ? (
						<>
							<Icon className="text-text-meta" icon={faWandMagicSparkles} />
							Auto-detect
						</>
					) : (
						`${selectedCount} selected`
					)}
				</span>
			</div>
			{compact ? (
				<Tooltip content="Define copywriting">
					<Button
						color={ButtonColor.ACTION_SECONDARY}
						disabled={isGenerating}
						image={<Icon className="text-text-meta" icon={faSliders} />}
						size={ButtonSize.XS}
						title=""
						onClick={onOpenFrameworksModal}
					/>
				</Tooltip>
			) : (
				<Button
					color={ButtonColor.ACTION_SECONDARY}
					disabled={isGenerating}
					image={<Icon className="mr-1.5 text-text-meta" icon={faSliders} />}
					size={ButtonSize.XS}
					title="Define copywriting"
					onClick={onOpenFrameworksModal}
				/>
			)}
		</div>
	);
};
